import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase/client';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'INITIAL_SESSION') {
        const tokenExpired = session?.expires_at
          ? session.expires_at * 1000 < Date.now()
          : false;

        if (!session || !tokenExpired) {
          // No session or fresh token — safe to show UI immediately
          setUser(session?.user ?? null);
          setLoading(false);
          if (session?.user && window.location.pathname === '/') {
            navigate('/dashboard');
          }
        }
        // If token is expired, keep loading=true and wait for TOKEN_REFRESHED or SIGNED_OUT
        return;
      }

      setUser(session?.user ?? null);
      setLoading(false);

      if (event === 'SIGNED_OUT') {
        navigate('/');
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  const login = async (email, password) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      if (error.message.includes('Invalid login credentials')) {
        throw new Error('Email ou senha inválidos.');
      }
      throw new Error(error.message);
    }

    navigate('/dashboard');
    return data.user;
  };

  const logout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    navigate('/');
  };

  const isAdmin = !!(user);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};
